import { render } from "./TakeOutCollectionItems.vue?vue&type=template&id=8693b254&scoped=true"
import script from "./TakeOutCollectionItems.vue?vue&type=script&lang=js"
export * from "./TakeOutCollectionItems.vue?vue&type=script&lang=js"

import "./TakeOutCollectionItems.vue?vue&type=style&index=0&id=8693b254&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8693b254"]])

export default __exports__